<template>
  <div class="HomeContainer">
    <div class="detailContainer" v-if="detail" key="detail">
      <div class="headContainer">
        <div>
          <div class="title">
            {{ detail.title }}

            <span class="purchase_count">
              <el-image
                :src="GetResourceUrl('home/icon-purchase_count.svg')"
              ></el-image>
              <div v-if="detail.auth_count" class="color-warning">
                <span style="font-size: 15px; margin-right: 2px">{{
                  detail.auth_count
                }}</span
                >{{ l("家已报价") }}
              </div>
              <div v-else style="font-weight: normal">{{ l("暂无报价") }}</div>
            </span>
          </div>
          <div class="created_time">
            {{ l("发布时间") }}：{{ $utils.i18nDate(detail.created_time) }}

            <!-- <i class="el-icon-view" style="margin: 0 5px 0 20px"></i
            >{{ detail.browse_count }} -->
          </div>
          <div class="collection_contact">
            <div v-if="detail.is_collect" class="collect" @click="collect">
              <el-image
                :src="GetResourceUrl('home/icon-collection_1.svg')"
              ></el-image>
              {{ l("已收藏") }}
            </div>
            <div v-else class="collect" @click="collect">
              <el-image
                :src="GetResourceUrl('home/icon-collection_0.svg')"
              ></el-image>
              {{ l("加入收藏") }}
            </div>

            <div
              v-if="!detail.is_expire"
              key="is_expire"
              class="contact"
              @click="getContact"
            >
              <el-image :src="GetResourceUrl('home/icon-tel.svg')"></el-image>
              {{ l("致电联系") }}
            </div>
          </div>
        </div>
        <div>
          <el-image
            v-if="detail.is_expire"
            style="width: 81px; height: 76px"
            :src="GetResourceUrl('home/icon-expire.svg')"
          ></el-image>
          <div
            v-else
            style="display: flex; flex-direction: column; align-items: center"
          >
            <div class="un_expire">
              {{ l("距离报价结束还剩") }}
              <span>{{ detail.expire_distance }}</span>
              {{ l("天") }}
            </div>
            <el-button
              type="warning"
              style="width: 120px; height: 40px; margin-top: 5px"
              @click="doBusiness"
              >{{
                detail.business_action_code ? l("修改我的报价") : l("我要报价")
              }}</el-button
            >
          </div>
        </div>
      </div>
      <div class="materialInfo">
        <div class="title">{{ l("基本信息") }}</div>
        <div class="amount">
          {{ l("需求") }}
          <span>
            {{ detail.specification_amount[0].amount }}
          </span>
          {{ detail.specification_amount[0].unit }}
        </div>
        <div class="tableContainer">
          <template v-if="detail.quality_type == 1 || detail.quality_type == 2">
            <div v-if="detail.quality_type == 1" class="column">
              <div class="header">{{ l("品类 品名") }}</div>
              <div class="content">
                {{ $store.getters.getCategory(detail.category_id) }}
                {{ detail.child_category }}
              </div>
            </div>
            <div class="column">
              <div class="header">{{ l("材料") }}</div>
              <div class="content">{{ detail.material }}</div>
            </div>
            <div class="column">
              <div class="header">{{ l("规格") }}</div>
              <div class="content">
                {{ detail.specification_amount[0].specification }}
              </div>
            </div>
            <div class="column">
              <div class="header">{{ l("钢厂") }}</div>
              <div class="content">{{ detail.steel_mill }}</div>
            </div>
          </template>

          <template v-else>
            <div class="column">
              <div class="header">{{ l("类型") }}</div>
              <div class="content">
                {{
                  $utils.listFilter(
                    $store.state.basicInfo.forge_typeList,
                    detail.forge_type
                  )
                }}
              </div>
            </div>
            <div class="column">
              <div class="header">{{ l("交货状态") }}</div>
              <div class="content">
                {{ detail.extra_params.extra_deliver_status || "-" }}
              </div>
            </div>
            <!-- <div class="column">
              <div class="header">工艺等级</div>
              <div class="content">
                {{ detail.extra_params.extra_technique || "-" }}
              </div>
            </div> -->
            <div class="column">
              <div class="header">{{ l("探伤") }}</div>
              <div class="content">
                {{ detail.extra_params.extra_flaw_detect || "-" }}
              </div>
            </div>
            <div class="column">
              <div class="header">{{ l("热处理") }}</div>
              <div class="content">
                {{ detail.extra_params.extra_heat_treatment || "-" }}
              </div>
            </div>
            <div class="column">
              <div class="header">{{ l("光洁度") }}</div>
              <div class="content">
                {{ detail.extra_params.extra_surface_grade || "-" }}
              </div>
            </div>
            <div class="column">
              <div class="header">{{ l("硬度") }}</div>
              <div class="content">
                {{ detail.extra_params.extra_hard || "-" }}
              </div>
            </div>
          </template>
        </div>
      </div>
      <div v-if="detail.img_array.length" class="img_arrayContainer">
        <div>{{ l("附件") }}</div>
        <el-image
          v-for="(item, index) of detail.img_array"
          :key="index"
          :src="item"
          fit="cover"
          :preview-src-list="detail.img_array"
        ></el-image>
      </div>
      <div class="otherInfo">
        <div class="title">{{ l("其他要求") }}</div>
        <div class="infoLines">
          <div class="line">
            {{ l("计重方式") }}：
            {{
              $utils.listFilter(
                $store.state.basicInfo.weight_methodList,
                detail.weight_method
              )
            }}
          </div>

          <div
            v-if="detail.quality_type == 1 || detail.quality_type == 2"
            class="line"
          >
            {{ l("需要质保书") }}：{{
              detail.have_warranty ? l("是") : l("否")
            }}
          </div>

          <div v-if="detail.quality_type == 3" class="line">
            {{ l("需要出具报告") }}：{{
              detail.have_report ? l("是") : l("否")
            }}
          </div>

          <div class="line">
            {{ l("收货地") }}：
            {{ detail.address }}
          </div>
          <div class="line">
            {{ l("截止日期") }}：
            {{ detail.expire_time.slice(0, 10) }}
          </div>
        </div>
      </div>

      <div v-if="detail.description" class="descriptionContainer">
        <div class="title">{{ l("补充说明") }}</div>
        <div class="description" v-html="detail.description"></div>
      </div>
    </div>
    <div v-if="showEmpty" class="emptyContainer" key="empty">
      <el-empty>
        <div slot="description">{{ l("抱歉，该需求不存在或已下架。") }}</div>
      </el-empty>
    </div>
    <BusinessDialog
      ref="businessDialog"
      :business_detail="detail"
      @submitDialog="businessCallback"
    />
  </div>
</template>

<script>
import BusinessDialog from "@/components/common/BusinessDialog";

export default {
  name: "HomePurchaseDetail",
  components: { BusinessDialog },
  data() {
    return {
      detail: null,
      imgIndex: 0,
      showEmpty: false,
    };
  },
  created() {
    this.getPurchaseDetail();
  },
  methods: {
    getPurchaseDetail() {
      this.axios
        .get(`/api/visitor_purchase/${this.$route.params.code}/`)
        .then((data) => {
          console.log("data", data);
          data.img_array = JSON.parse(data.img_array);
          var date1 = new Date(
            ...this.$utils.formatDate(new Date()).split("-")
          );
          var date2 = new Date(...data.expire_time.slice(0, 10).split("-"));
          data.expire_distance = Math.max(
            0,
            parseInt(date2.getTime() - date1.getTime()) / (1000 * 60 * 60 * 24)
          );
          // data.is_expire = true;
          this.detail = data;
        })
        .catch(() => {
          this.showEmpty = true;
        });
    },
    collect() {
      if (this.detail.is_collect) {
        //axios delete的body需要包装在data内
        this.axios
          .delete(`/api/user_collection/cancel/`, {
            data: {
              code: this.detail.code,
            },
          })
          .then(() => {
            this.detail.is_collect = false;
          });
      } else {
        this.axios
          .post(`/api/user_collection/`, {
            code: this.detail.code,
            module: "purchase",
          })
          .then(() => {
            this.detail.is_collect = true;
          });
      }
    },
    doBusiness() {
      this.$refs.businessDialog.Show({
        module: "purchase",
      });
    },
    businessCallback(formData) {
      console.log("formData", formData);
      if (formData.code) {
        this.axios
          .put(`/api/business_action/${formData.code}/`, formData)
          .then(() => {});
      } else {
        this.axios.post(`/api/business_action/`, formData).then((res) => {
          this.detail.business_action_code = res.code; //更新business_action_code
        });
      }
    },
    getContact() {
      this.axios
        .get(`/api/account/get_contact/`, {
          params: {
            module: "purchase",
            code: this.detail.code,
          },
        })
        .then((res) => {
          this.$alert(res.mobile, res.display_name);
        });
    },
  },
};
</script>


<style scoped lang="scss">
.detailContainer {
  padding: 35px 30px 50px;
  background-color: #fff;
  margin-top: 15px;
  .headContainer {
    display: flex;
    justify-content: space-between;
    padding-bottom: 40px;
    border-bottom: 1px solid $borderPlainColor;
    .title {
      font-size: 18px;
      font-weight: bold;
      width: 900px;
      .purchase_count {
        font-size: 13px;
        color: $warningColor;
        display: inline-flex;
        align-items: center;
        margin-left: 12px;
        .el-image {
          width: 19px;
          height: 17px;
          margin-right: 5px;
        }
      }
    }
    .created_time {
      color: #999;
      margin-top: 10px;
    }
    .collection_contact {
      display: flex;
      margin-top: 10px;
      .collect,
      .contact {
        display: flex;
        align-items: center;
        cursor: pointer;
        .el-image {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }
      }
      .collect {
        color: #666;
      }
      .contact {
        margin-left: 15px;
        color: $linkColor;
      }
    }

    .un_expire {
      position: relative;
      top: -15px;
      span {
        color: $warningColor;
        font-size: 30px;
        margin: 0 10px;
      }
    }
  }
}
.materialInfo {
  .title {
    padding-left: 8px;
    border-left: 2px solid $warningColor;
    line-height: 14px;
    height: 14px;
    margin-top: 30px;
    font-weight: bold;
  }
  .amount {
    margin-top: 20px;
    span {
      font-size: 30px;
      color: $warningColor;
    }
  }
  .tableContainer {
    margin-top: 30px;
    display: flex;
    box-sizing: border-box;
    border: 1px solid $borderPlainColor;
    .column {
      width: 25%;
      flex-grow: 1;
      .header {
        padding: 12px 0 12px 25px;
        background: $borderPlainColor;
      }
      .content {
        padding: 16px 0 16px 25px;
      }
    }
  }
}

.img_arrayContainer {
  margin-top: 35px;
  color: #666;
  display: flex;
  .el-image {
    width: 74px;
    height: 74px;
    margin-left: 15px;
  }
}

.otherInfo {
  .title {
    padding-left: 8px;
    border-left: 2px solid $warningColor;
    line-height: 14px;
    height: 14px;
    margin-top: 45px;
    font-weight: bold;
  }
  .infoLines {
    margin: 30px 0;
    .line {
      display: flex;
      margin-top: 10px;
    }
  }
}

.descriptionContainer {
  border-top: 1px solid $borderPlainColor;
  box-sizing: border-box;
  .title {
    line-height: 14px;
    height: 14px;
    margin-top: 30px;
    font-weight: bold;
  }
  .description {
    margin-top: 20px;
    width: 100%;
  }
}
.emptyContainer {
  background: #fff;
  margin-top: 15px;
  box-sizing: border-box;
  padding: 100px 0 120px;
}
</style>

